import React, { useState } from "react";
import "./Gallery.css";

const Gallery = () => {
  const [activeImage, setActiveImage] = useState(null);

  const images = [
    "/images/hero.png",
    "/images/about.webp",
    "/images/services.png",
    "/images/contact.png",
  ];

  return (
    <section className="gallery-page">
      <h2 className="gallery-title">Event Gallery</h2>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div
            key={index}
            className="gallery-item"
            onClick={() => setActiveImage(img)}
          >
            <img src={img} alt={`Event ${index + 1}`} />
          </div>
        ))}
      </div>

      {activeImage && (
        <div
          className="gallery-lightbox"
          onClick={() => setActiveImage(null)}
        >
          <img src={activeImage} alt="Event enlarged" />
        </div>
      )}
    </section>
  );
};

export default Gallery;